(function () {
  function updateInventoryElement(el) {
    if (!el) return;

    var variantId = el.getAttribute('data-variant-id');
    var realQty = parseInt(el.getAttribute('data-real-qty') || '0', 10);
    var label = el.querySelector('.js-product-inventory-label');

    if (!variantId || !label) return;

    // Als echte voorraad laag is, tonen we die eerlijk, dat voelt het meest betrouwbaar
    if (realQty > 0 && realQty <= 10) {
      if (realQty === 1) {
        label.textContent = 'Nog slechts 1 stuks beschikbaar.';
      } else {
        label.textContent = 'Nog slechts ' + realQty + ' stuks beschikbaar.';
      }
      return;
    }

    // Voor grotere voorraden gebruiken we per klant een vast getal 1 t/m 10
    var storageKey = 'tm_inventory_' + variantId;
    var shownQty;

    try {
      shownQty = window.localStorage.getItem(storageKey);

      if (!shownQty) {
        shownQty = Math.floor(Math.random() * 10) + 1; // 1 t/m 10
        window.localStorage.setItem(storageKey, String(shownQty));
      } else {
        shownQty = parseInt(shownQty, 10);
        if (!shownQty || shownQty < 1 || shownQty > 10) {
          shownQty = Math.floor(Math.random() * 10) + 1;
          window.localStorage.setItem(storageKey, String(shownQty));
        }
      }

      if (shownQty === 1) {
        label.textContent = 'Nog slechts 1 stuks beschikbaar.';
      } else {
        label.textContent = 'Nog slechts ' + shownQty + ' stuks beschikbaar.';
      }
    } catch (e) {
      // Als localStorage niet werkt, val terug op een veilige tekst
      label.textContent = 'Op voorraad, direct leverbaar';
    }
  }

  function initInventory(root) {
    var scope = root || document;
    scope.querySelectorAll('.js-product-inventory').forEach(function (el) {
      updateInventoryElement(el);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initInventory(document);
  });

  // Als jouw theme events triggert bij variant wissel, kunnen we daarop inhaken
  document.addEventListener('product:variant-change', function (event) {
    if (event.detail && event.detail.container) {
      initInventory(event.detail.container);
    }
  });
})();